export function generateRandomString(length: number) {
    const randomString = Math.floor(Math.random() * Math.pow(10, length)).toString();
    
    return randomString.padStart(length, '0');
}
